import { useEffect } from "react";
import {
  getTrans,
  transStatusChange,
  transAmountChange,
  getLatest,
  getLatestTest,
} from "../utils/api";
import { useState } from "react";
import { Transaction } from "../utils/types";
export const useTransactions = (snackbarRef?: any, filters?: any) => {
  const [transactions, setTransactions] = useState<Transaction[]>([]);
  const [allTransactions, setAllTransactions] = useState<Transaction[]>([]);
  const [page, setPage] = useState<number>(1);

  useEffect(() => {
    if (allTransactions.length === 0) {
      fetchRecentTrans(page, "фильтры", filters);
    } else {
      const lastIndex = page * 20;
      const firstIndex = lastIndex - 20;
      const currentItems = allTransactions.slice(firstIndex, lastIndex);
      setTransactions(currentItems);
      window.scrollTo(0, 0);
    }
  }, [page]);

  const [total, setTotal] = useState<number>(0);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string>("");
  const [totalPage, setTotalPage] = useState<number>(0);

  const fetchRecentTrans = async (
    page: number,
    type: string,
    filters?: any,
  ) => {
    setError("");
    setLoading(true);
    setAllTransactions([]);
    setTransactions([]);
    try {
      try {
        const res =
          type === "фильтры"
            ? await getLatestTest({
                page: page,
                filters: filters ?? {},
              })
            : await getLatest({ page: page });
        const data = res.data;
        setTransactions(data.items);
        setTotal(data.total_count);
        setTotalPage(data.total_pages);
      } catch (err) {
        setError("Failed to fetch transactions");
        console.error(err);
      }
    } finally {
      return setLoading(false);
    }
  };
  const fetchTransactions = async (filterss: any) => {
    setError("");
    setLoading(true);

    const filters = Object.fromEntries(
      Object.entries(filterss).filter(
        ([key, value]) => key === "search_query" && value,
      ),
    );

    try {
      const res = await getTrans(filters);
      const data = res.data;
      setPage(1);
      setTotal(data.length);
      setTotalPage(Math.ceil(data.length / 20));
      setAllTransactions(data);

      if (data.length > 20) {
        const lastIndex = page * 20;
        const firstIndex = lastIndex - 20;
        const currentItems = data.slice(firstIndex, lastIndex);
        setTransactions(currentItems);
      } else {
        setTransactions(data);
      }
    } catch (err) {
      setError("Failed to fetch transactions");
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const handleStatusChange = async (
    newStatus: "created" | "completed" | "canceled" | "dispute",
    transactionId: string,
  ) => {
    snackbarRef.current.showSnackbar(
      `Меняем статус транзакции c id ${transactionId} на ${newStatus}`,
      "info",
    );

    setTransactions((prevFiltered) =>
      prevFiltered.map((t) =>
        t.id === transactionId ? { ...t, status: newStatus } : t,
      ),
    );
    await transStatusChange(newStatus, transactionId)
      .then(() =>
        snackbarRef.current.showSnackbar(
          `Статус транзакции c id ${transactionId} успешно изменен на ${newStatus}`,
          "success",
        ),
      )
      .catch(() => {
        snackbarRef.current.showSnackbar(
          `Произошла ошибка при изменении статуса транзакции с id ${transactionId}`,
          "error",
        );
      });
  };
  const handleAmountChange = async (
    newAmount: number,
    transactionId: string,
  ) => {
    snackbarRef.current.showSnackbar(
      `Меняем сумму транзакции c id ${transactionId} на ${newAmount}`,
      "info",
    );
    setTransactions((prevFiltered) =>
      prevFiltered.map((t) =>
        t.id === transactionId ? { ...t, sum_confirmed: newAmount } : t,
      ),
    );
    await transAmountChange(newAmount, transactionId)
      .then(() =>
        snackbarRef.current.showSnackbar(
          `Сумма транзакции c id ${transactionId} успешно изменена на ${newAmount}`,
          "success",
        ),
      )
      .catch(() => {
        snackbarRef.current.showSnackbar(
          `Произошла ошибка при изменении суммы транзакции с id ${transactionId}`,
          "error",
        );
      });
  };
  /**
   * Тихое обновление для автообновления страницы.
   *
   * fetchRecentTrans чистит список и поднимает loading — на каждом тике это
   * моргало бы скелетоном и сбрасывало прокрутку. Здесь строки подменяются на
   * месте, а ошибка не показывается: пропущенный тик не повод рушить экран,
   * данные останутся прежними до следующей попытки.
   */
  const refreshQuietly = async (filters?: any) => {
    try {
      const res = await getLatestTest({ page: 1, filters: filters ?? {} });
      const data = res.data;
      setTransactions(data.items);
      setTotal(data.total_count);
      setTotalPage(data.total_pages);
      return true;
    } catch {
      return false;
    }
  };

  return {
    transactions,
    loading,
    error,
    fetchTransactions,
    handleStatusChange,
    handleAmountChange,
    fetchRecentTrans,
    refreshQuietly,
    total,
    setTotal,
    setTransactions,
    page,
    setPage,
    totalPage,
  };
};
